// extracted by mini-css-extract-plugin
export default {"logoImage":"styles_logoImage__+sqjD","title":"styles_title__vqeNw","line":"styles_line__rhpvs","backButton":"styles_backButton__kjhcy"};